import { createSlice } from "@reduxjs/toolkit";

export interface DocsSidebarState {
  isVisible: boolean;
}

const initialState: DocsSidebarState = {
  isVisible: true,
};

export const docsSidebarSlice = createSlice({
  name: "docsSidebar",
  initialState,
  reducers: {
    closeDocsSidebar: (state) => {
      state.isVisible = false;
    },
    openDocsSidebar: (state) => {
      state.isVisible = true;
    },
    toggleDocsSidebar: (state) => {
      state.isVisible = !state.isVisible;
    },
  },
});

export const { closeDocsSidebar, openDocsSidebar, toggleDocsSidebar } =
  docsSidebarSlice.actions;

export default docsSidebarSlice.reducer;
